import PromptInputType from "common/enums/PromptInputType";
import GrowType from "common/enums/form/responsive/GrowType";

function calcMaxOfControl(control, props) {
    var pad = props.padding * 2;
    if (control.inputType === PromptInputType.H_LINE) {
        //Horizontal lines should never drive the size of a form
        return 0;
    } else if (control.growType === GrowType.SHRINK || control.growType === GrowType.FIXED) {
        return control.renderedWidth + pad;
    } else {
        return props.maxWidth + pad;
    }
}

/**
 * Get the maximum size of an array.
 */
export default function sizeOfForm(controls, props) {
    var rowWidth = [];
    controls.forEach(function(control) {
        var row = control.row;
        if (!rowWidth[row]) {
            rowWidth[row] = 0;
        }
        rowWidth[row] += calcMaxOfControl(control, props);
    });
    rowWidth.push(320); // form can never drop below 320
    return Math.max.apply(null, rowWidth);
}
